import { GlButton, GlDisclosureDropdown, GlIcon, GlLoadingIcon, GlTooltipDirective } from '@gitlab/ui';
import { BV_HIDE_TOOLTIP, BV_SHOW_TOOLTIP } from '~/lib/utils/constants';
export default {
    name: 'ActionButtons',
    components: {
        GlButton,
        GlDisclosureDropdown,
        GlIcon,
        GlLoadingIcon
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    props: {
        tertiaryButtons: {
            type: Array,
            required: true
        }
    },
    emits: [
        'clicked-action'
    ],
    data () {
        return {
            timeout: null,
            updatingTooltip: false
        };
    },
    computed: {
        dropdownItems () {
            return this.tertiaryButtons.map((button)=>{
                return {
                    text: button.text,
                    href: button.href,
                    action: ()=>this.onClickAction(button),
                    icon: button.icon || button.iconName,
                    loading: button.loading,
                    extraAttrs: {
                        dataClipboardText: button.dataClipboardText,
                        dataMethod: button.dataMethod,
                        target: button.target,
                        rel: button.rel,
                        disabled: button.disabled
                    }
                };
            });
        }
    },
    methods: {
        onClickAction (action, e = null) {
            this.$emit('clicked-action', action);
            if (action.onClick) {
                action.onClick(action, e);
            }
            if (action.tooltipOnClick) {
                this.updatingTooltip = true;
                this.$root.$emit(BV_SHOW_TOOLTIP, action.id);
                clearTimeout(this.timeout);
                this.timeout = setTimeout(()=>{
                    this.updatingTooltip = false;
                    this.$root.$emit(BV_HIDE_TOOLTIP, action.id);
                }, 1000);
            }
        },
        setTooltip (btn) {
            if (this.updatingTooltip && btn.tooltipOnClick) {
                return btn.tooltipOnClick;
            }
            return btn.tooltipText;
        }
    }
};
